export interface ClientAccessFilterType {
  clientAccesses: server.dto.ClientAccess[]
  selectedClientAccesses: server.dto.ClientAccess[]
}

export const getSortedClientAccessLabels = (filter: ClientAccessFilterType) => {
  return filter.selectedClientAccesses.map(v => v.text)
    .sort((a, b) => a.localeCompare(b));
};

export const initialClientAccessFilter: ClientAccessFilterType = {
  clientAccesses: [],
  selectedClientAccesses: []
};
